import React from 'react'
import { FaPoundSign } from 'react-icons/fa'
const Error = () => {
  return (
<div className="section-center text-center">
  <h2>there was an error...</h2>
</div>

  )
}





export default Error
